import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faCheckCircle, faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
export const ProcessingStep = ({ isProcessing, currentIndex, totalRecords, processingError, hasCompleted, rowClassName, }) => {
    const getIcon = () => {
        if (isProcessing) {
            return _jsx(FontAwesomeIcon, { icon: faSpinner, spin: true });
        }
        if (processingError) {
            return _jsx(FontAwesomeIcon, { icon: faExclamationTriangle });
        }
        if (hasCompleted) {
            return _jsx(FontAwesomeIcon, { icon: faCheckCircle });
        }
        return _jsx(FontAwesomeIcon, { icon: faSpinner });
    };
    const getRightContent = () => {
        if (isProcessing) {
            return (_jsxs("span", { children: ["Processing ", currentIndex, " of ", totalRecords, "..."] }));
        }
        if (processingError) {
            return _jsx("span", { children: processingError });
        }
        if (hasCompleted) {
            return _jsx("span", { children: "Complete" });
        }
        return _jsx("span", { className: "email-credentials__pending-text", children: "Ready to process" });
    };
    return (_jsxs("div", { className: `email-credentials__workflow-row ${rowClassName}`, children: [_jsxs("div", { className: "email-credentials__row-left", children: [getIcon(), _jsx("span", { className: "email-credentials__row-label", children: "Send Credential Emails" })] }), _jsx("div", { className: "email-credentials__row-right", children: getRightContent() })] }));
};
